/*
	File: slider-events.js
	Author: D McCleod
	Created: 2/13/2017
	Modified:
	Description: handle slick events
*/

//TODO: find better implementation for setTimeout in virtualTracking call

import { pagination } from './pagination';
import { isInfiniteScroll } from './init-slideshow';
import { virtualTracking, dataTracking } from './slide-tracking';
import { toast } from './toast-alert';
import { checkMediaQuery } from './matchmedia-checker';
import * as hashManager from './hash-manager';
import * as config from './config';
import { contentMarketing } from './content-mrk-ad';
import { lazyLoadImages } from './lazy-load';

window.slideShow = window.slideShow || {};

var imageLoadCount = 0,
    readMorePadding = 65,
    navEvent = window.slideShow.navEvent,
    topEleHeights = null,
    holdVirtualTracking = {
        _event: '',
        track: function(){
            virtualTracking(this._event);
        }
    };

$(window)
    .on('orientationchange', function (event) {
        // do not call the resize function for infinite scroll slideshows because slick is not initialized
        if(window.slideShowVars.infiniteScroll) return;
        config.slideContainer.slick('resize');
    })
    .on('resetSlideHeight', (e, data) => {
        resetSlideHeight(data);
    });

config.slideContainer
    .on('init', function(event, slick) {
        $(window).trigger('slideshow:initialized');
        slideShow.orientation = getScreenOrientation();

        lazyLoadImages(slick,slick.currentSlide);
        const currentSlideNum = slick.slickCurrentSlide() + 1;
        // used in the resetSlideHeight function
        topEleHeights = slideShow.header.height() + slideShow.navHeader.height();

        window.slideShow.slideCount = slick.slideCount;
        pagination.setTotalSlides(window.slideShow.slideCount);
        pagination.setInitialSlide(isMscpApp ? 1 : hashManager.getHash());
        toggleSlideClasses(hashManager.currentHash);

        //add class for infinitescroll
        if(isInfiniteScroll) config.slideShowWrapper.addClass('infinitescroll');

        //remove inline css from nav arrows, added by Slick
        $(config.configObj.prevArrow).add(config.configObj.nextArrow).removeAttr('style');

        // set handler for all nav arrows
        dataTracking();

        if(( checkMediaQuery('mq1') || checkMediaQuery('mq2') ) &&  currentSlideNum !==  slick.slideCount && !isMscpApp) {
            toast.init();
        } else if(currentSlideNum === slick.slideCount && !isMscpApp){
            // remove toast if on last slide
            toast.removeToast();
        }

        // initialize content marketing
        if(slideShow.useContentMrk && breakpoint === 1 && !isInfiniteScroll) contentMarketing.initContent(slick);
    })
    .on('afterChange', function(event, slick, currentSlide) {
        let slideHash = currentSlide + 1;
        if(toast.isVisible) toast.fadeOutToast();
        if(hashManager.currentHash !== slideHash) {
            const $slide = getSlideElement(slick.slickCurrentSlide());
            const adContainer = $slide.find(`.${contentMarketing.contentAdClass}`);
            if(adContainer[0] !== undefined) {
                $(window).trigger('afterslidechange', {
                    container: adContainer,
                    slide: $slide,
                    index: currentSlide
                });
            }

            location.hash = slideHash;
            //update internal history
            hashManager.hashHistory.push(slideHash);
            hashManager.setLastHash();

            // call virtual tracking ONLY when interstitial ad is not present, pass navEvent object, has type and data attribute values
            if(window.slideShow.displayInterstitial) {
                // when the interstitial add is displayed, store the event in an object, then call the virtualTracking function when the ad closes
                holdVirtualTracking._event = slideShow.navEvent;
            } else {
                virtualTracking(slideShow.navEvent);
            }
        }
    })
    .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        // will trigger the interstitial ad when count and frequency are equal
        $(window)
            .delay(300).trigger('interad:countchange', {slideIndex: nextSlide})
            .trigger('beforeslidechange', {
                prev:  getSlideElement(currentSlide),
                next: getSlideElement(nextSlide),
                index: currentSlide
            })
        // ! CAUTION: event is triggered on swipe up or down, not just before the slide is about to change, sometimes is triggered 2x
    })
    .on('swipe', function(event, slick, direction){
        slideShow.navEvent.type = event.type;
        slideShow.navEvent.data = 'ss-swipe';

        slideShow.slickNavEngaged = true;
        setSliderDirection(direction);
    })
    .on('lazyLoaded', function(event, slick, image, imageSource) {
        // trigger any events after each image is loaded, imageLoadCount counts all images, including those in related slide thumbnails
        imageLoadCount ++;
    })
    .on('lazyLoadError', function(event, slick, image, imageSource) {
        //console.log('==> lazyLoadError on', imageSource);
    });

// track slider direction on arrow clicks or swipe
$(config.configObj.prevArrow).on('click', function() {
    setSliderDirection('left');
});
$(config.configObj.nextArrow).on('click', function() {
    setSliderDirection('right');
});

function resetSlideHeight(sdata) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            let resetHeight, fallBackHeight = topEleHeights + 325;
            if(sdata.collapsed) {
                resetHeight = Math.round(sdata.adHeight - (topEleHeights - 10));
            } else {
                resetHeight = sdata.slide.height() + readMorePadding;
            }
            // fallBackHeight in case the resetHeight is too small, ad should not be cut off
            resetHeight = (fallBackHeight > resetHeight) ? fallBackHeight : resetHeight;
            resolve(resetHeight);
        }, 500);
    }).then((newHeight) => {
        sdata.list.animate({
            height: newHeight
        }, 700, () => {
            slideShow.resetSlideHeight = false;
        });
        if(slideShow.isScrolling) slideShow.isScrolling = false;
    });
}

function setSliderDirection(direction) {
    window.slideShow.direction = direction;
    return direction;
}

function getScreenOrientation() {
    return (window.outerWidth > window.outerHeight) ? 'landscape' : 'portrait';
}

/* !!! goToSlide triggers the 'afterChange' event */
function goToSlide(index) {
    // a 1 must be subtracted from the index to match the pagination and hash, since the index starts at 0.
    config.slideContainer.slick('slickGoTo', index -1);
}

function scrollTo(position) {
    slideShow.isScrolling = true;
    $('html, body').animate({
        scrollTop: position
    }, 500, () => {
        slideShow.isScrolling = false;
        $(window).trigger('scroll:ended');
    });
}

function getSlideElement(id){
    return $(`[data-slick-index="${id}"]`);
}

// use to toggle classes on the wrapper when first or last slides are visible class names: "first-slide"  "last-slide"
function toggleSlideClasses(currentSlide) {
    if(config.startSlide == currentSlide) {
        config.slideShowWrapper.toggleClass(config.wrapperClassNames[0]).removeClass(config.wrapperClassNames[1]);
    } else if(window.slideShow.slideCount == currentSlide) {
        config.slideShowWrapper.toggleClass(config.wrapperClassNames[1]).removeClass(config.wrapperClassNames[0]);
    } else {
        $.map(config.wrapperClassNames, function(val) {
            if(config.slideShowWrapper.hasClass(val)) config.slideShowWrapper.removeClass(val);
        });
    }
}


export {
    goToSlide,
    toggleSlideClasses,
    scrollTo,
    getSlideElement,
    getScreenOrientation,
    holdVirtualTracking,
    navEvent
};